import { FilterBodyType } from '@screens/Category/model/types/categoryFilters';
import { CategoryProductsResponse } from '@screens/Category/model/types/categoryProducts';
import { CLIENT_URL, SERVER_URL } from '@shared/config/api/api';

type GetProductsForCategoryProps = {
  category: string;
  params: FilterBodyType;
  signal?: AbortSignal;
  server?: boolean;
};

export const getProductsForCategory = async (
  config: GetProductsForCategoryProps
): Promise<CategoryProductsResponse> => {
  const { signal, category, params, server } = config;

  let url = CLIENT_URL;

  if (server) {
    url = SERVER_URL;
  }

  const response = await fetch(`${url}/products/category/${category}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(params),
    signal,
    next: {
      tags: ['catalog']
    }
  });

  const data = await response.json();

  data.pagination = {
    limit: params.limit,
    skip: params.skip
  };

  data.sort = params.sort;

  return await data;
};
